(function ($) {
    'use strict';

    let isRTL = $('body').prop('dir') === 'rtl';

    jQuery(document).ready(function () {
        $('select').niceSelect();

        // reply
        $(document).on('click', '.reply', function () {
            $(this).toggleClass("reply-active");
            $(this).parent().next(".reply__content").slideToggle();
        });

        let $dataTable = $('.table_register')
        if ($dataTable.length > 0) {
            $dataTable.DataTable( {
                "language": {
                    "lengthMenu": "Hiển thị _MENU_ bản ghi",
                    "zeroRecords": "Nothing found - sorry",
                    "info": "Đang hiển thị trang _PAGE_ trên _PAGES_",
                    "infoEmpty": "Không tìm thấy kết quả",
                    "infoFiltered": "(filtered from _MAX_ total records)",
                    "paginate": {
                        "previous": `<i class="bi bi-chevron-left"></i>`,
                        "next": `<i class="bi bi-chevron-right"></i>`
                    },
                    search: "Tìm kiếm:",
                },
                pageLength: 10,
                lengthMenu: [ [10, 20, 50, -1], [10, 20, 50, "Tất cả"] ]
            });
        }
    })

    $(document).ready(function () {
        const $imageBox = $('.image-box-favicon');
        const $fileInput = $imageBox.find('.image-data');
        const $previewImg = $imageBox.find('.preview-image');
        const defaultImage = $previewImg.data('default');

        // Trigger chọn ảnh khi click ảnh hoặc chữ "Chọn ảnh"
        $('#triggerImageSelect, #triggerImageSelectText').on('click', function (e) {
            e.preventDefault();
            $fileInput.trigger('click');
        });

        // Preview ảnh
        $fileInput.on('change', function () {
            const file = this.files[0];
            if (file && file.type.startsWith('image/')) {
                const reader = new FileReader();

                reader.onload = function (e) {
                    $previewImg.attr('src', e.target.result).removeClass('default-image');
                };

                reader.readAsDataURL(file);
            }
        });

        // Xóa ảnh
        $('#removeImageBtn').on('click', function () {
            $fileInput.val('');
            $previewImg.attr('src', defaultImage).addClass('default-image');
        });

        // Trigger chọn file
        $('#triggerFileSelect, #triggerFileSelectText').on('click', function (e) {
            e.preventDefault();
            $('.image-box:not(.image-box-favicon) .image-data').trigger('click');
        });

        // Preview file (nếu cần)
        $('.image-box:not(.image-box-favicon) .image-data').on('change', function () {
            const file = this.files[0];
            if (file) {
                // Có thể hiển thị tên file
                console.log('File selected:', file.name);
            }
        });

        // Xóa file
        $('#removeFileBtn').on('click', function () {
            $('.image-box:not(.image-box-favicon) .image-data').val('');
        });
    });

    function getComments(page) {
        const url = $('input[name="urlAjax"]').val()
        const sortBy = $('#setSortComments').val()

        const pathParts = window.location.pathname.split('/');
        const id = pathParts[pathParts.length - 1];

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                id: id,
                sort_by: sortBy,
                page: page,
            },
            beforeSend: function () {
                $('.container-comments .list-content-loading').show();
            },
            success: function (response) {
                $('#include-comments').html(response.data.html)
                $('.container-comments .list-content-loading').hide();
            },
            error: function () {
                $('.container-comments .list-content-loading').hide();
                window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
            }
        });
    }

    function likeComment(url, data_id) {
        const pathParts = window.location.pathname.split('/');
        let id = data_id || pathParts[pathParts.length - 1];

        $.ajax({
            url: url,
            type: 'POST',
            data: {
                id: id
            },
            beforeSend: function () {

            },
            success: function (response) {

                if(!response.error) {
                    $('#like-container').html(response.data.html)
                    $('.voting_container').html(response.data.html_button)
                    $('#total_like_event').text(response.data.count)
                    window.showAlert('alert-success', response.message);
                }
            },
            error: function () {
                window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
            }
        });
    }

    function getCommentsProduct(page) {
        const url = $('.container-comments-product input[name="urlAjax"]').val()
        const sortBy = $('#setSortCommentsProduct').val()

        let id = url.split('/').pop();
        console.log(id)

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                id: id,
                sort_by: sortBy,
                page: page,
            },
            beforeSend: function () {
                $('.container-comments-product .list-content-loading').show();
            },
            success: function (response) {
                $('.container-comments-product .comments-area .list-comments').html(response.data.html)
                $('.container-comments-product .list-content-loading').hide();
            },
            error: function () {
                $('.container-comments-product .list-content-loading').hide();
                window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
            }
        });
    }

    $(document).on('click', '.container-comments-product .page-link', function () {
        event.preventDefault()
        const url = $(this).attr('href')
        const page = new URL(url).searchParams.get('page');
        getCommentsProduct(page)

    });

    $(document).on('click', '.like-event', function () {
        event.preventDefault()
        const url = $(this).attr('href')
        let data_id = $(this).attr('data-id')
        $(this).toggleClass('button-loading')
        likeComment(url, data_id)

    });

    $(document).on('click', '.unlike-event', function () {
        event.preventDefault()
        const url = $(this).attr('href')
        let data_id = $(this).attr('data-id')
        $(this).toggleClass('button-loading')
        likeComment(url, data_id)
    });

    $(document).on('click', '.container-comments .page-link', function () {
        event.preventDefault()
        const url = $(this).attr('href')
        const page = new URL(url).searchParams.get('page');
        getComments(page)

    });

    $(document).on('change', '#setSortEvents', function () {
        const sortBy = $(this).val();
        const url = $('input[name="urlSortEvents"]').val();
        $.ajax({
            url: url,
            type: 'GET',
            data: {
                sort_by: sortBy
            },
            beforeSend: function () {
                // Hiện loading
                $('#EventsContainer .list-content-loading').show();
            },
            success: function (response) {
                $('#EventsContainer').html(response.data.html)
                $('#EventsContainer .list-content-loading').hide();
                $('select').niceSelect();

                // Cập nhật URL
                const params = new URLSearchParams(window.location.search);
                params.set('sort_by', sortBy);
                const newUrl = window.location.pathname + '?' + params.toString();
                window.history.replaceState({}, '', newUrl);
            },
            error: function () {
                window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
            }
        });
    });

    $(document).on('change', '#setSortComments', function () {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page') || 1;
        getComments(page)
    });

    $(document).on('change', '#setSortCommentsProduct', function () {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page') || 1;
        getCommentsProduct(page)
    });

    $(document).on('click', '.submit-Comment', function () {
        console.log(1111);

        event.preventDefault();

        const $form = $(this).closest('form');
        const url = $form.attr('action');
        const formData = $form.serialize();

        $.ajax({
            url: url,
            method: 'POST',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $('.write-commnets .list-content-loading').show();
            },
            success: function (response) {
                $('.write-commnets .list-content-loading').hide();
                if (response.error) {
                    return window.showAlert('alert-danger', response.message);
                }

                window.showAlert('alert-success', 'Gửi bình luận thành công! Chúng tôi sẽ xem xét trước khi công khai');

                // setTimeout(function () {
                //     location.reload();
                // }, 2000);

                $form.find('input, textarea, select, button').prop('disabled', true);
                $form.addClass('form-disabled')
                $form[0].reset();
                // $form[0].remove()
            },
            error: function (xhr) {
                $('.write-commnets .list-content-loading').hide();
                window.showAlert('alert-danger', 'Gửi bình luận thất bại!');
            }
        });
    });

    $(document).on('click', '.btn_join_campaign', function () {
        event.preventDefault()
        const url = $(this).attr('href')
        const pathParts = window.location.pathname.split('/');
        const slug = pathParts[pathParts.length - 1];

        $.ajax({
            url: url,
            type: 'POST',
            data: {
                slug: slug,
            },
            beforeSend: function () {

            },
            success: function (response) {
                if(!response.error) {
                    let $button = $('.container_join_campaign .btn_join_campaign')
                    $button.html(`Đã tham gia <span></span>`).removeClass('btn_join_campaign')
                    window.showAlert('alert-success', response.message);
                }
            },
            error: function () {
                window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
            }
        });
    });

    $(document).on('click', '.post_comments_product', function () {
        event.preventDefault()
        const $form = $(this).closest('form');
        const url = $form.attr('action');
        const formData = $form.serialize();
        const $this = $(this)
        $this.addClass('button-loading').prop('disabled', true)

        $.ajax({
            url: url,
            method: 'POST',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function (response) {

                if (response.error) {
                    $this.removeClass('button-loading').prop('disabled', false)
                    return window.showAlert('alert-danger', response.message);
                }

                window.showAlert('alert-success', 'Gửi bình luận thành công! Chúng tôi sẽ xem xét trước khi công khai')
                $form[0].reset();
                $this.removeClass('button-loading').prop('disabled', false)
            },
            error: function (xhr) {
                $this.removeClass('button-loading').prop('disabled', false)
                window.showAlert('alert-danger', 'Gửi bình luận thất bại!');
            }
        });
    });

    let typingTimer;
    let doneTypingInterval = 500;

    $('.form_search_expert').on('keyup', function () {
        clearTimeout(typingTimer);
        let query = $(this).val().trim();
        let url = $('#url_search_expert').val()

        typingTimer = setTimeout(function () {
            const newUrl = updateQueryStringParameter(window.location.href, 'keyword', query);
            window.history.replaceState(null, '', newUrl);

            $.ajax({
                url: url,
                method: 'GET',
                data: { keyword: query },
                beforeSend: function() {
                    $('#result-expert .list-content-loading').show();
                },
                success: function (data) {
                    setTimeout(() => {
                        $('#result-expert .list-content-loading').hide();
                        $('#result-expert').html(data.data.html);
                    }, "700");

                },
                error: function () {
                    $('#result-expert .list-content-loading').hide();
                    alert("Có lỗi xảy ra.");
                }
            });

        }, doneTypingInterval);
    });

    // Cập nhật query string
    function updateQueryStringParameter(uri, key, value) {
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (value === "") {
            const cleanUri = uri.replace(re, '$1').replace(/[?&]$/, '');
            return cleanUri;
        }
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + encodeURIComponent(value) + '$2');
        } else {
            return uri + separator + key + "=" + encodeURIComponent(value);
        }
    }

    $('#search-box-phieu').on('keydown', function () {
        clearTimeout(typingTimer);
    });



    // Page loading

    $(window).on('load', function () {
        $('#preloader-active').fadeOut();
        $('body').css({
            'overflow': 'visible'
        });
        $(".preloader").delay(300).animate({
            "opacity": "0"
        }, 800, function () {
            $(".preloader").css("display", "none");
        });
    });

    $(document).on('click', '#post_request_consultation .submit_request', function (event) {

        event.preventDefault();
        const $form = $(this).closest('form');
        const $modal = $('#requestConsultationModal')
        const url = $form.attr('action');
        const formData = $form.serialize();

        $.ajax({
            url: url,
            method: 'POST',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            beforeSend: function () {
                $('#requestConsultationModal .list-content-loading').show();
            },
            success: function (response) {
                $('#requestConsultationModal .list-content-loading').hide();
                if (response.error) {
                    return window.showAlert('alert-danger', response.message);
                }

                window.showAlert(`alert-success`, response.message);

                // setTimeout(function () {
                //     location.reload();
                // }, 2000);

                $modal.modal('hide')
                $form[0].reset();

            },
            error: function (xhr) {
                $('#requestConsultationModal .list-content-loading').hide();
                window.showAlert('alert-danger', xhr.responseJSON.message);
            }
        });
    });

    $("#postAnswer").validate({
        // ignore: [],
        submitHandler: function(form) {
            event.preventDefault()
            const $form = $('#postAnswer');
            const url = $form.attr('action');
            let formData = new FormData(form);
            // const formData = $form.serialize();

            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: function () {
                    $('#postAnswer .list-content-loading').show();
                },
                success: function (response) {
                    $('#postAnswer .list-content-loading').hide();

                    if (response.error) {
                        return window.showAlert(`alert-${response.data}`, response.message);
                    }
                    window.showAlert(`alert-${response.data}`, response.message);
                    $form.find('input, textarea, select, button').prop('disabled', true);
                    $form.addClass('form-disabled')
                    $form[0].reset();

                    setTimeout(() => {
                        location.reload()
                    }, "2000");

                },
                error: function () {
                    $('#postAnswer .list-content-loading').hide();
                    window.showAlert('alert-danger', 'Đã xảy ra lỗi, vui lòng thử lại.');
                }
            });
        },
        invalidHandler: function(event, validator) {

            $('.collapse').each(function () {
                let $collapse = $(this);
                if (!$collapse.hasClass('show')) {
                    $collapse.collapse('show');
                }
            });

            if (validator.errorList.length > 0) {
                let firstErrorElement = $(validator.errorList[0].element);
                $('html, body').animate({
                    scrollTop: firstErrorElement.offset().top - 200
                }, 500);
            }
            window.showAlert('alert-danger', 'Vui lòng nhập đầy đủ câu trả lời của bạn!');
        }
    });

    /*-----------------
        Menu Stick
    -----------------*/
    var header = $('.sticky-bar');
    var win = $(window);
    const $headerArea = $('header.header-area');
    win.on('scroll', function () {
        var scroll = win.scrollTop();
        if (scroll < 200) {
            header.removeClass('stick');
            if ($headerArea.find('.categories-dropdown-active-large').hasClass('default-open')) {
                $headerArea.find('.categories-dropdown-active-large').addClass('open');
                $headerArea.find('.categories-button-active').addClass('open');
            }
        } else {
            $headerArea.find('.categories-dropdown-active-large').removeClass('open');
            $headerArea.find('.categories-button-active').removeClass('open');
            header.addClass('stick');
        }
    });

    let backToTop = function () {
        let scrollPos = 0;
        let element = $('#scrollUp');
        $(window).scroll(function () {
            let scrollCur = $(window).scrollTop();
            if (scrollCur > scrollPos) {
                // scroll down
                if (scrollCur > 500) {
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            } else {
                // scroll up
                element.removeClass('active');
            }

            scrollPos = scrollCur;
        });

        element.on('click', function () {
            $('html, body').animate(
                {
                    scrollTop: '0px',
                },
                0
            );
        });
    }

    // nav-right__search
    $(".nav-right__search-icon").on("click", function (event) {
        event.stopPropagation();
        $(this).toggleClass("active");
        $(this).parent().next(".nav-right__search-inner").slideToggle();
    });
    $(document).on("click", function (event) {
        if (!$(event.target).closest(".nav-right__search-icon, .nav-right__search-inner").length) {
            $(".nav-right__search-inner").slideUp();
            $(".nav-right__search-icon").removeClass("active");
        }
    });

    // btn_theme
    $(function() {
        $(document)
            .on('mouseenter', '.btn_theme', function(e) {
                var parentOffset = $(this).offset(),
                    relX = e.pageX - parentOffset.left,
                    relY = e.pageY - parentOffset.top;
                $(this).find('span').css({top:relY, left:relX})
            })
            .on('mouseout', '.btn_theme', function(e) {
                var parentOffset = $(this).offset(),
                    relX = e.pageX - parentOffset.left,
                    relY = e.pageY - parentOffset.top;
                $(this).find('span').css({top:relY, left:relX})
            });
    });

    //--View All Content
    $(".view-btn").on("click", function () {
        $(this).toggleClass("view-active");
        $(this).parents().next(".view-content-wrap").toggleClass("active").slideToggle();
    });

    function initSlider() {
        if (!$.fn.slick) {
            return;
        }

        $('.product-experience-slider').each(function () {
            var $slider = $(this);
            var sliderId = $slider.attr('id');
            var appendArrowsClassName = '#' + sliderId + '-arrows';

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $slider.slick({
                dots: false,
                infinite: true,
                speed: 800,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToShow: 4,
                slidesToScroll: 1,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
                prevArrow: '<span class="slider-btn slider-prev"><i class="far fa-chevron-left"></i></span>',
                nextArrow: '<span class="slider-btn slider-next"><i class="far fa-chevron-right"></i></span>',
                appendArrows: appendArrowsClassName,
            });
        });
    }

    function getModal() {
        return $('#productExperienceModal');
    }

    function closeModal() {
        var $modal = getModal();
        var $video = $modal.find('.product-experience-modal__video');
        var player = $video.get(0);

        if (player) {
            player.pause();
        }
        $video.attr('src', '');
        $modal.find('.product-experience-modal__gallery').empty();
        $modal.removeClass('is-open').attr('aria-hidden', 'true');
        $('body').removeClass('product-experience-modal-open');
    }

    function openModal(item) {
        var $modal = getModal();
        var $video = $modal.find('.product-experience-modal__video');
        var $gallery = $modal.find('.product-experience-modal__gallery');

        $modal.find('.product-experience-modal__title').text(item.title || '');
        $video.attr('src', item.video_url || '');
        $gallery.empty();

        if (Array.isArray(item.gallery) && item.gallery.length) {
            item.gallery.forEach(function (image) {
                $gallery.append('<img src="' + image + '" alt="Experience image">');
            });
        }

        $modal.addClass('is-open').attr('aria-hidden', 'false');
        $('body').addClass('product-experience-modal-open');
        var player = $video.get(0);
        if (player) {
            var playPromise = player.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                    // Ignore autoplay rejection by browser policy
                });
            }
        }
    }

    $(document).on('click', '.experience-video-item', function () {
        var item = $(this).data('experience-item');
        if (!item) {
            return;
        }

        openModal(item);
    });

    $(document).on('click', '[data-experience-close]', function () {
        closeModal();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    });

    $(function () {
        initSlider();
    });

    // testimonials-slider
    $(".testimonials-slider")
        .not(".slick-initialized")
        .slick({
            infinite: true,
            autoplay: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 1500,
            arrows: true,
            dots: false,
            prevArrow: $(".prev-testimonials1"),
            nextArrow: $(".next-testimonials1"),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    },
                }
            ],
        });

    /*------ Wow Active ----*/
    // new WOW().init();

    //sidebar sticky
    if ($('.sticky-sidebar').length) {
        $('.sticky-sidebar').theiaStickySidebar();
    }

    /**
     * Number.prototype.format_price(n, x)
     *
     * @param n
     * @param x
     */
     Number.prototype.format_price = function(n, x) {
        let currencies = window.currencies || {};
        if (!n) {
            n = currencies.number_after_dot != undefined ? currencies.number_after_dot : 2;
        }
        let re = '\\d(?=(\\d{' + (x || 3) + '})+$)';
        let priceUnit = '';
        let price = this;
        if (currencies.show_symbol_or_title) {
            priceUnit = currencies.symbol || currencies.title;
        }
        if (currencies.display_big_money) {
            if (price >= 1000000 && price < 1000000000) {
                price = price / 1000000;
                priceUnit = currencies.million + (priceUnit ? ' ' + priceUnit : '');
            } else if (price >= 1000000000) {
                price = price / 1000000000;
                priceUnit = currencies.billion + (priceUnit ? ' ' + priceUnit : '');
            }
        }
        price = price.toFixed(Math.max(0, ~~n));
        price = price.toString().split('.');
        price = price[0].toString().replace(new RegExp(re, 'g'), '$&' + currencies.thousands_separator) + (price[1] ? currencies.decimal_separator + price[1] : '');
        if (currencies.show_symbol_or_title) {
            if (currencies.is_prefix_symbol) {
                price = priceUnit + price;
            } else {
                price = price + priceUnit;
            }
        }
        return price;
    };

    // Slider Range JS
    if ($('.slider-range').length) {
        $('.slider-range').map(function (i, el) {
            const $this = $(el);
            const $parent = $this.closest('.range');
            const $min = $parent.find('input.min-range');
            const $max = $parent.find('input.max-range');
            $this.slider({
                range: true,
                min: $min.data('min') || 0,
                max: $max.data('max') || 500,
                values: [$min.val() || 0, $max.val() || 500],
                slide: function (event, ui) {
                    setInputRange($parent, ui.values[0], ui.values[1]);
                }
            });
            setInputRange($parent, $this.slider("values", 0), $this.slider("values", 1));
        });
    }

    function setInputRange($parent, min, max) {
        let $filter = $parent.closest('.widget-filter-item');
        let minFormatted = min;
        let maxFormatted = max;
        if ($filter.length && $filter.data('type') == 'price') {
            minFormatted = minFormatted.format_price();
            maxFormatted = maxFormatted.format_price();
        }
        const $from = $parent.find('.from');
        const $to = $parent.find('.to');
        $parent.find('input.min-range').val(min);
        $parent.find('input.max-range').val(max);
        $from.text(minFormatted);
        $to.text(maxFormatted);
    }


    /*------ Hero slider 1 ----*/
    let $mainSlider = $('.hero-slider-1');
    $mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: isRTL,
        speed: 500,
        autoplay: true,
        infinite: true,
        autoplaySpeed: $mainSlider.data('autoplay-speed') ? $mainSlider.data('autoplay-speed') : 3000,
        fade: true,
        loop: true,
        dots: false,
        arrows: true,
        prevArrow: '<span class="slider-btn slider-prev"><i class="far fa-chevron-left"></i></span>',
        nextArrow: '<span class="slider-btn slider-next"><i class="far fa-chevron-right"></i></span>',
        appendArrows: '.hero-slider-1-arrow'
    });

    // Khi click vào tab
    $('.tab-item').on('click', function(){
        var index = $(this).index();
        $mainSlider.slick('slickGoTo', index);
        $('.tab-item').removeClass('active');
        $(this).addClass('active');
    });

    $mainSlider.on('afterChange', function(event, slick, currentSlide){
        $('.tab-item').removeClass('active');
        $('.tab-item').eq(currentSlide).addClass('active');
    });

    // Tự động thay đổi tab theo slider (nếu dùng autoplay)
    $mainSlider.on('afterChange', function(event, slick, currentSlide){
        $('.tab-item').removeClass('active');
        $('.tab-item').eq(currentSlide).addClass('active');
    });

    /*Carousel 6 columns*/
    $('.carousel-6-columns').each(function () {
        var id = $(this).attr('id');
        var sliderID = '#' + id;
        var appendArrowsClassName = '#' + id + '-arrows';

        let slickOptions = $(this).data('slick') || {}

        $(sliderID).slick({
            dots: false,
            rtl: isRTL,
            arrows: true,
            autoplay: slickOptions.autoplay === 'yes',
            infinite: slickOptions.infinite === 'yes',
            speed: slickOptions.speed ? slickOptions.speed : 1000,
            autoplaySpeed: slickOptions.autoplaySpeed ? slickOptions.autoplaySpeed : 3000,
            slidesToShow: 6,
            slidesToScroll: 1,
            loop: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
            prevArrow: '<span class="slider-btn slider-prev"><i class="far fa-chevron-left"></i></span>',
            nextArrow: '<span class="slider-btn slider-next"><i class="far fa-chevron-right"></i></span>',
            appendArrows: appendArrowsClassName,
        });
    });

    /*Carousel 6 columns*/
    $('.carousel-5-columns').slick({
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 1000,
        autoplaySpeed: 3000,
        slidesToShow: 5,
        rows: 2,
        slidesToScroll: 1,
        loop: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ],
        prevArrow: '<span class="slider-btn slider-prev"><i class="far fa-chevron-left"></i></span>',
        nextArrow: '<span class="slider-btn slider-next"><i class="far fa-chevron-right"></i></span>',
    });

    /* Carousel 4 columns */
    $('.carousel-4-columns').each(function () {
        var id = $(this).attr('id');
        var sliderID = '#' + id;
        var appendArrowsClassName = '#' + id + '-arrows';

        $(sliderID).slick({
            dots: false,
            infinite: true,
            rtl: isRTL,
            speed: 1000,
            arrows: true,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            loop: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            prevArrow: '<span class="slider-btn slider-prev"><i class="far fa-chevron-left"></i></span>',
            nextArrow: '<span class="slider-btn slider-next"><i class="far fa-chevron-right"></i></span>',
            appendArrows: appendArrowsClassName,
        });
    });

    /*Fix Bootstrap 5 tab & slick slider*/

    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        $('.carousel-4-columns').slick('setPosition');
    });

    /*------ Timer Countdown ----*/

    let trans = key => {
        window.trans = window.trans || {};

        return window.trans[key] !== 'undefined' && window.trans[key] ? window.trans[key] : key;
    }

    // $('[data-countdown]').each(function () {
    //     var $this = $(this), finalDate = $(this).data('countdown');
    //     $this.countdown(finalDate, function (event) {
    //
    //         $(this).html(
    //             event.strftime(''
    //                 + '<span class="countdown-section"><span class="countdown-amount hover-up">%D</span><span class="countdown-period"> ' + trans('days') + ' </span></span>'
    //                 + '<span class="countdown-section"><span class="countdown-amount hover-up">%H</span><span class="countdown-period"> ' + trans('hours') + ' </span></span>'
    //                 + '<span class="countdown-section"><span class="countdown-amount hover-up">%M</span><span class="countdown-period"> ' + trans('mins') + ' </span></span>'
    //                 + '<span class="countdown-section"><span class="countdown-amount hover-up">%S</span><span class="countdown-period"> ' + trans('sec') + ' </span></span>'
    //             )
    //         );
    //     });
    // });

    /*----------------------------
        Category toggle function
    ------------------------------*/
    var searchToggle = $('.categories-button-active');
    searchToggle.on('click', function (e) {
        e.preventDefault();
        if ($headerArea.find('.categories-button-active').hasClass('cant-close') && !header.hasClass('stick')) {
            return false;
        } else {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).siblings('.categories-dropdown-active-large').removeClass('open');
                if (!$headerArea.find('.categories-button-active').hasClass('cant-close')) {
                    $(this).siblings('.categories-dropdown-active-large').removeClass('default-open');
                }
            } else {
                $(this).addClass('open');
                $(this).siblings('.categories-dropdown-active-large').addClass('open');
            }
        }
    })

    /*---------------------
        Price range
    --------------------- */
    var sliderrange = $('#slider-range');
    var amountprice = $('#amount');
    if (sliderrange.length) {
        $(function () {
            sliderrange.slider({
                range: true,
                min: 16,
                max: 400,
                values: [0, 300],
                slide: function (event, ui) {
                    amountprice.val("$" + ui.values[0] + " - $" + ui.values[1]);
                }
            });
            amountprice.val("$" + sliderrange.slider("values", 0) +
                " - $" + sliderrange.slider("values", 1));
        });
    }


    /*-------------------------------
        Sort by active
    -----------------------------------*/
    if ($('.sort-by-product-area').length) {
        var $body = $('body'),
            $cartWrap = $('.sort-by-product-area'),
            $cartContent = $cartWrap.find('.sort-by-dropdown');
        $body.on('click', '.sort-by-product-area .sort-by-product-wrap', function (e) {
            e.preventDefault();
            var $this = $(this);
            if (!$this.parent().hasClass('show')) {
                $this.siblings('.sort-by-dropdown').addClass('show').closest('.sort-by-product-area').addClass('show');
            } else {
                $this.siblings('.sort-by-dropdown').removeClass('show').closest('.sort-by-product-area').removeClass('show');
            }
        });
        /*Close When Click Outside*/
        $body.on('click', function (e) {
            var $target = e.target;
            if (!$($target).is('.sort-by-product-area') && !$($target).parents().is('.sort-by-product-area') && $cartWrap.hasClass('show')) {
                $cartWrap.removeClass('show');
                $cartContent.removeClass('show');
            }
        });
    }

    /*-----------------------
        Shop filter active
    ------------------------- */
    var shopFiltericon = $('.shop-filter-toggle');
    shopFiltericon.on('click', function (e) {
        e.preventDefault();
        $('.shop-product-filter-header').slideToggle();
        $('.shop-filter-toggle').toggleClass('active');
    });

    function closeShopFilterSection () {
        if ($('.shop-filter-toggle').hasClass('active')) {
            $('.shop-product-filter-header').slideToggle();
            $('.shop-filter-toggle').removeClass('active');
        }
    }

    window.closeShopFilterSection = closeShopFilterSection;

    /*-------------------------------------
        Product details big image slider
    ---------------------------------------*/
    $('.pro-dec-big-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: isRTL,
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.product-dec-slider-small , .product-dec-slider-small-2',
    });

    /*---------------------------------------
        Product details small image slider
    -----------------------------------------*/
    $('.product-dec-slider-small').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        rtl: isRTL,
        asNavFor: '.pro-dec-big-img-slider',
        dots: false,
        focusOnSelect: true,
        fade: false,
        arrows: false,
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
            }
        },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    /*-----------------------
        Magnific Popup
    ------------------------*/
    if ($('.img-popup').length) {
        $('.img-popup').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }

    /*---------------------
        Select active
    --------------------- */

    // Isotope active
    if ($('.grid').length) {
        $('.grid').imagesLoaded(function () {
            // init Isotope
            var $grid = $('.grid').isotope({
                itemSelector: '.grid-item',
                percentPosition: true,
                layoutMode: 'masonry',
                masonry: {
                    // use outer width of grid-sizer for columnWidth
                    columnWidth: '.grid-item',
                }
            });
        });
    }

    /*====== SidebarSearch ======*/
    function sidebarSearch() {
        var searchTrigger = $('.search-active'),
            endTriggersearch = $('.search-close'),
            container = $('.main-search-active');

        searchTrigger.on('click', function (e) {
            e.preventDefault();
            container.addClass('search-visible');
        });

        endTriggersearch.on('click', function () {
            container.removeClass('search-visible');
        });

    };
    sidebarSearch();

    /*====== Sidebar menu Active ======*/
    function mobileHeaderActive() {
        var navbarTrigger = $('.burger-icon'),
            endTrigger = $('.mobile-menu-close'),
            container = $('.mobile-header-active'),
            wrapper4 = $('body');

        wrapper4.prepend('<div class="body-overlay-1"></div>');

        navbarTrigger.on('click', function (e) {
            e.preventDefault();
            container.addClass('sidebar-visible');
            wrapper4.addClass('mobile-menu-active');
        });

        endTrigger.on('click', function () {
            container.removeClass('sidebar-visible');
            wrapper4.removeClass('mobile-menu-active');
        });

        $('.body-overlay-1').on('click', function () {
            container.removeClass('sidebar-visible');
            wrapper4.removeClass('mobile-menu-active');
        });
    };
    mobileHeaderActive();


    /*---------------------
         Mobile menu active
     ------------------------ */
    var $offCanvasNav = $('.mobile-menu'),
        $offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');

    /*Add Toggle Button With Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="far fa-chevron-down"></i></span>');

    /*Close Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.slideUp();

    /*Category Sub Menu Toggle*/
    $offCanvasNav.on('click', 'li a, li .menu-expand', function (e) {
        var $this = $(this);
        if (($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length) {
                $this.parent('li').removeClass('active');
                $this.siblings('ul').slideUp();
            } else {
                $this.parent('li').addClass('active');
                $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
                $this.closest('li').siblings('li').find('ul:visible').slideUp();
                $this.siblings('ul').slideDown();
            }
        }
    });

    /*--- language currency active ----*/
    $('.mobile-language-active').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.single-mobile-header-info').find('.lang-dropdown-active').slideToggle(900);
    });

    /*--- categories-button-active-2 ----*/
    $('.categories-button-active-2').on('click', function (e) {
        e.preventDefault();
        $('.categories-dropdown-active-small').slideToggle(900);
    });

    $('.mobile-menu-wrap .main-categories-wrap .categories-dropdown-wrap .menu-expand').on('click', function (e) {
        e.preventDefault();
        $(this).closest('li').find('.dropdown').slideToggle(900);
    });

    /*-----More Menu Open----*/
    $('.more_slide_open').slideUp();
    $('.more_categories').on('click', function () {
        $(this).toggleClass('show');
        $('.more_slide_open').slideToggle();
    });

    /*--- VSticker ----*/
    $('#news-flash').vTicker({
        speed: 500,
        pause: 3000,
        animation: 'fade',
        mousePause: false,
        showItems: 1
    });

    var productDetails = function () {
        let slider = $('.product-image-slider');

        if (slider.length) {
            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: isRTL,
                arrows: false,
                fade: false,
                asNavFor: '.slider-nav-thumbnails',
            });

            $('.slider-nav-thumbnails').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                rtl: isRTL,
                asNavFor: '.product-image-slider',
                dots: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
            });

            // Remove active class from all thumbnail slides
            let slickSlide = $('.slider-nav-thumbnails .slick-slide');
            slickSlide.removeClass('slick-active');

            // Set active class to first thumbnail slides
            slickSlide.eq(0).addClass('slick-active');

            // On before slide change match active thumbnail to current slide
            slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var mySlideNumber = nextSlide;
                slickSlide.removeClass('slick-active');
                slickSlide.eq(mySlideNumber).addClass('slick-active');
            });

            slider.lightGallery({
                selector: '.slick-slide:not(.slick-cloned) a',
                thumbnail: true,
                share: false,
                fullScreen: false,
                autoplay: false,
                autoplayControls: false,
                actualSize: false,
            });
        }

        //Filter color/Size
        $('.list-filter').each(function () {
            $(this).find('a').on('click', function (event) {
                event.preventDefault();
                $(this).parent().siblings().removeClass('active');
                $(this).parent().toggleClass('active');
                $(this).parents('.attr-detail').find('.current-size').text($(this).text());
                $(this).parents('.attr-detail').find('.current-color').text($(this).attr('data-color'));
            });
        });

        $(document).on('click', '.dropdown-menu .cart_list', function(e) {
            e.stopPropagation();
        });

        let listCategories = $('.ps-list--categories');
        if (listCategories.length > 0) {
            $('.ps-list--categories .menu-item-has-children > .sub-toggle').on(
                'click',
                function(e) {
                    e.preventDefault();
                    let current = $(this).parent('.menu-item-has-children');
                    $(this).toggleClass('active');
                    current
                        .siblings()
                        .find('.sub-toggle')
                        .removeClass('active');
                    current.children('.sub-menu').slideToggle(350);
                    current
                        .siblings()
                        .find('.sub-menu')
                        .slideUp(350);
                    if (current.hasClass('has-mega-menu')) {
                        current.children('.mega-menu').slideToggle(350);
                        current
                            .siblings('.has-mega-menu')
                            .find('.mega-menu')
                            .slideUp(350);
                    }
                }
            );
        }
    };
    /* WOW active */
    // new WOW().init();

    //Load functions
    $(document).ready(function () {
        productDetails();
        backToTop();
    });

    $(document).on("ready", function () {
    });
})(jQuery);
